var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("slide-y-down-transition", [
    _vm.show
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: function() {
                  return _vm.$emit("close")
                },
                expression: "() => $emit('close')"
              }
            ],
            staticClass: "filters px-24 pt-24 w-100"
          },
          [
            _c("div", {
              staticClass: "filter-close",
              domProps: { innerHTML: _vm._s(_vm.svg("icon-close")) },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.chunkedCategories, function(chunk, chunkindex) {
              return _c(
                "div",
                { key: chunkindex, staticClass: "row mb-lg-24" },
                _vm._l(chunk, function(parentCategory) {
                  return _c(
                    "div",
                    {
                      key: parentCategory.id,
                      staticClass:
                        "col-12 mb-24 mb-lg-0 col-lg-4 d-flex flex-wrap justify-content-start align-content-start"
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "font-weight-light small w-100 mb-24" },
                        [_vm._v(_vm._s(parentCategory.parent.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(parentCategory.children, function(category) {
                        return _c(
                          "div",
                          { key: category.id, staticClass: "tag-col d-flex" },
                          [
                            _c("a", {
                              staticClass: "tag tag-sm mb-8 mr-auto",
                              class:
                                _vm.selectedCategories.find(function(sc) {
                                  return sc.id === category.id
                                }) !== undefined
                                  ? "tag-accent"
                                  : "tag-gray",
                              domProps: { innerHTML: _vm._s(category.name) },
                              on: {
                                click: function($event) {
                                  return _vm.toggleAndEmitCategory(category)
                                }
                              }
                            })
                          ]
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            }),
            _vm._v(" "),
            _vm.cta
              ? _c("div", { staticClass: "row mb-24" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-accent",
                        attrs: { href: _vm.ctaLink }
                      },
                      [_vm._v(_vm._s(_vm.cta))]
                    )
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }